import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const NavLink = styled(Link)`
  color: ${(props) => props.theme.colors.tfpWhite};
  text-decoration: none;
`;
